<img class="image" [attr.src]="src() | secureImage | async" [alt]="alt()" />
